module.exports = __webpack_public_path__ + "static/media/user.cb82ab5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/Dashboard/static/img/user.png
// module id = 1294
// module chunks = 0